import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../utils/apiBaseQuery";
import { AuthenticationSettingsInterface } from "../interfaces/account/AuthenticationSettingsInterface";
import { mapAuthenticationSettingsResponse } from "./adapters/mapAuthenticationSettingsResponse";

export const accountApiSlice = createApi({
    reducerPath: "accountApi",
    baseQuery: apiBaseQuery(),
    tagTypes: ["AuthSettings"],
    endpoints: (builder) => ({
        getAuthSettings: builder.query<AuthenticationSettingsInterface, void>({
            query: () => "apiV2/dealer/authentication-settings",
            transformResponse: mapAuthenticationSettingsResponse,
            providesTags: ["AuthSettings"],
        }),
        setAuthMethod: builder.mutation<
            AuthenticationSettingsInterface,
            {
                authentication_method: string;
                code: string;
                phone_number: string | null;
            }
        >({
            query: (params) => ({
                url: "apiV2/dealer/authentication-settings",
                method: "PATCH",
                body: {
                    authentication_method: params.authentication_method,
                    code: params.code,
                    phone_number: params.phone_number,
                },
            }),
            transformResponse: mapAuthenticationSettingsResponse,
            invalidatesTags: ["AuthSettings"],
        }),
        sendAuthCode: builder.mutation<
            void,
            { authentication_method: string; phone_number: string | null }
        >({
            query: (params) => ({
                url: "apiV2/dealer/authentication-settings/send-code",
                method: "POST",
                body: {
                    authentication_method: params.authentication_method,
                    phone_number: params.phone_number,
                },
            }),
        }),
    }),
});

export const {
    useGetAuthSettingsQuery,
    useLazyGetAuthSettingsQuery,
    useSetAuthMethodMutation,
    useSendAuthCodeMutation,
} = accountApiSlice;
